import axios from 'axios';
import API_HOST from '../api';

const getUrlStub = (options) => {
  let stub = `${API_HOST}/api`;

  if (options.hasOwnProperty('clientId')) {
    stub += `/client/${options.clientId}`;
  }

  if (options.hasOwnProperty('userId')) {
    stub += `/user/${options.userId}`;
  }

  return stub;
};

const mapViewApi = {};

/*
 * Check Map View name to determine validity
 */
mapViewApi.checkName = (options, name) => {
  const url = `${getUrlStub(options)}/form-validation/duplicate`
  
  return axios.get(url, {
    params: {
      'has-user': !options.userId ? true : undefined,
      input: name,
      field: 'name',
      resource: 'map-view',
    },
  });
};


/*
 * Create Map View
 */
mapViewApi.createMapView = (options, mapView) => {
  const url = `${getUrlStub(options)}/map-view`;

  return axios.post(url, mapView);
};


/*
 * Delete Map View
 */
mapViewApi.deleteMapView = (options) => {
  const url = `${getUrlStub(options)}/map-view/${options.id}`;

  return axios.delete(url);
};


/*
 * Get Map View
 */
mapViewApi.getMapView = (options) => {
  const url = `${getUrlStub(options)}/map-view/${options.id}`;

  return axios.get(url);
};


/*
 * Get list of Map Views
 */
mapViewApi.getMapViews = (options) => {
  const url = `${getUrlStub(options)}/map-view-list`;

  return axios.get(url);
};


/*
 * Set default Map View
 */
mapViewApi.setDefaultMapView = (options) => {
  const url = `${getUrlStub(options)}/map-view/${options.id}/default`;

  return axios.post(url);
};


/*
 * Update Map View
 */
mapViewApi.updateMapView = (options, mapView) => {
  const url = `${getUrlStub(options)}/map-view/${options.id}`;

  return axios.put(url, mapView);
};

export default mapViewApi;
